if (!customElements.get('natunora-cart')) {
  customElements.define('natunora-cart', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.model = window.NatunoraCartModel;
      this.variantPrices = JSON.parse(this.querySelector('[data-cart-variant-prices]').textContent);
      this.packImages = JSON.parse(this.querySelector('[data-cart-images]')?.textContent || '{}');
      this.giftProducts = JSON.parse(this.querySelector('[data-cart-gifts]')?.textContent || '[]');
      if (!this.model || !this.dialog.showModal) return;
      this.root = this.dataset.root || '/';
      this.busy = false;
      this.cart = null;
      this.ready = false;
      this.revision = 0;
      this.previousKachingHandler = window.kachingBundlesDisableAddToCartHandling;
      window.kachingBundlesDisableAddToCartHandling = true;
      document.addEventListener('click', event => {
        const add = event.target.closest('button[name=add]');
        if (add?.form?.matches('form#natunora-home-product-form, form[data-natunora-offer-form], product-form form')) {
          event.preventDefault();
          event.stopPropagation();
          if (add.form.reportValidity()) this.addForm(add.form);
          return;
        }
        const trigger = event.target.closest('[data-natunora-cart-open]');
        if (trigger && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
          event.preventDefault();
          this.open(trigger);
        }
      }, { ...this.options, capture: true });
      document.addEventListener('submit', event => {
        const form = event.target;
        if (!form.matches('form#natunora-home-product-form, form[data-natunora-offer-form], product-form form') || !form.querySelector('[name=add]')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.addForm(event.target);
      }, { ...this.options, capture: true });
      this.addEventListener('click', event => this.onClick(event), this.options);
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, this.options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.close();
      }, this.options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('natunora-cart-open');
        this.trigger?.setAttribute('aria-expanded', 'false');
        if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
      }, this.options);
      this.querySelector('[data-cart-checkout]').closest('form').addEventListener('submit', event => {
        if (this.busy || !this.ready || !this.cart?.item_count || this.foreign || this.invalid) event.preventDefault();
      }, this.options);
      window.addEventListener('pageshow', () => {
        const returning = this.checkoutPending;
        this.checkoutPending = false;
        if (returning && this.trigger) this.purchaseLoading(this.trigger, false);
        if (returning || this.dialog.open) this.refresh().catch(() => {});
      }, this.options);
      document.querySelectorAll('[data-natunora-cart-open]').forEach(el => {
        el.setAttribute('aria-haspopup', 'dialog');
        el.setAttribute('aria-expanded', 'false');
      });
      this.refresh().catch(() => {});
    }
    disconnectedCallback() {
      this.revision++;
      this.controller?.abort();
      this.dialog?.close();
      window.kachingBundlesDisableAddToCartHandling = this.previousKachingHandler;
    }
    async request(path, body) {
      const response = await fetch(`${this.root}${path}`, {
        method: body ? 'POST' : 'GET',
        credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000),
        headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      const data = await response.json();
      if (!response.ok || data.errors) throw new Error(typeof data.description === 'string' ? data.description : typeof data.errors === 'string' ? data.errors : 'Der Warenkorb konnte nicht aktualisiert werden. Bitte versuche es erneut.');
      return data;
    }
    async refresh() {
      const revision = ++this.revision;
      this.ready = false;
      this.lock(this.busy);
      const cart = await this.request('cart.js');
      if (revision !== this.revision || !this.isConnected) return;
      this.cart = cart;
      this.ready = true;
      this.render();
      return cart;
    }
    async open(trigger) {
      this.trigger = trigger || document.activeElement;
      this.closing?.cancel();
      if (!this.dialog.open) this.dialog.showModal();
      document.documentElement.classList.add('natunora-cart-open');
      this.trigger?.setAttribute('aria-expanded', 'true');
      this.querySelector('#NatunoraCartTitle').focus({ preventScroll: true });
      if (this.busy) return;
      this.error('');
      try { await this.refresh(); } catch { this.error('Der Warenkorb ist gerade nicht erreichbar. Bitte erneut laden.'); }
    }
    close() {
      if (!this.dialog.open) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return this.dialog.close();
      const style = getComputedStyle(document.documentElement);
      this.closing?.cancel();
      const animation = this.dialog.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(100%)' }], { duration: parseFloat(style.getPropertyValue('--natunora-motion-duration')) || 200, easing: style.getPropertyValue('--natunora-motion-easing').trim() || 'ease' });
      this.closing = animation;
      animation.finished.then(() => this.dialog.close()).catch(() => {});
    }
    error(message) {
      const el = this.querySelector('[data-cart-error]');
      el.replaceChildren();
      el.hidden = !message;
      if (!message) return;
      el.append(document.createTextNode(message + ' '));
      const retry = document.createElement('button');
      retry.type = 'button'; retry.dataset.cartRetry = ''; retry.textContent = 'Erneut laden'; el.append(retry);
    }
    lock(busy) {
      this.busy = busy;
      this.setAttribute('aria-busy', String(busy));
      this.querySelectorAll('[data-line-plus], [data-line-minus], [data-line-remove], [data-cart-extra], [data-cart-clear-foreign]').forEach(el => { el.disabled = busy || !this.ready; });
      this.querySelector('[data-cart-checkout]').disabled = busy || !this.ready || !this.cart?.item_count || this.foreign || this.invalid;
      this.querySelector('[data-cart-status]').textContent = busy ? 'Warenkorb wird aktualisiert.' : '';
    }
    async mutate(action, focusId, focusAction) {
      if (this.busy) return;
      this.error('');
      this.lock(true);
      try {
        await action();
        await this.cleanExtraCode();
        await this.refresh();
        this.querySelector('[data-cart-status]').textContent = 'Warenkorb aktualisiert.';
        this.lock(false);
        const row = Array.from(this.querySelectorAll('[data-group]')).find(el => el.dataset.group === focusId);
        if (this.dialog.open) (row?.querySelector(focusAction || '[data-line-remove]') || this.querySelector('#NatunoraCartTitle')).focus({ preventScroll: true });
        return true;
      } catch (error) {
        try { await this.refresh(); } catch { this.ready = false; }
        this.error(error.message || 'Bitte prüfe den Warenkorb, bevor du es erneut versuchst.');
        return false;
      } finally { this.lock(false); }
    }
    purchaseLoading(button, loading) {
      button.disabled = loading;
      if (!button.matches?.('[data-main-buy]')) return;
      if (loading) {
        this.purchaseLabel = button.getAttribute('aria-label');
        button.setAttribute('aria-label', 'Wird geladen. Du wirst zur Kasse weitergeleitet.');
        button.setAttribute('aria-busy', 'true');
      } else {
        button.removeAttribute('aria-busy');
        if (this.purchaseLabel === null) button.removeAttribute('aria-label');
        else button.setAttribute('aria-label', this.purchaseLabel);
      }
    }
    async addForm(form, options = {}) {
      if (this.busy || this.checkoutPending) return;
      const button = options.button || form.querySelector('[name="add"]');
      const scope = form.closest('product-info') || form;
      const block = scope.querySelector('kaching-bundles-block');
      let items;
      try {
        if (scope.querySelector('kaching-bundle, kaching-bundles-block')) {
          if (!block || typeof block.items !== 'function' || typeof block.validateItemSelection !== 'function') throw new Error('Das Angebot lädt noch. Bitte versuche es gleich erneut.');
          if (!block.validateItemSelection().valid) return;
          block.rotateBundleNonce();
          const title = block.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-title')?.textContent.trim() || 'Dein Paket';
          items = this.model.bundleItems(block.items(), title);
        } else {
          const data = new FormData(form);
          const item = { id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1), properties: {} };
          for (const [key, value] of data) { const match = key.match(/^properties\[(.+)\]$/); if (match) item.properties[match[1]] = value; }
          if (data.get('selling_plan')) item.selling_plan = Number(data.get('selling_plan'));
          items = [item];
        }
        if (options.oneTime) items = this.model.oneTimeItems(items);
        if (typeof window !== 'undefined' && window.natunoraOfferExperiment?.prepareItems) items = window.natunoraOfferExperiment.prepareItems(form, items);
      } catch (error) { await this.open(button); this.error(error.message); return; }
      this.trigger = button;
      this.purchaseLoading(button, true);
      const added = await this.mutate(() => this.request('cart/add.js?kaching_bundles=true', { items }));
      if (added && this.ready && this.cart?.item_count && !this.foreign && !this.invalid) {
        this.checkoutPending = true;
        this.goToCheckout();
        return true;
      }
      this.purchaseLoading(button, false);
      if (!this.dialog.open) this.dialog.showModal();
      document.documentElement.classList.add('natunora-cart-open');
      this.querySelector('#NatunoraCartTitle').focus({ preventScroll: true });
    }
    goToCheckout() {
      window.location.assign(`${this.root}checkout`);
    }
    async onClick(event) {
      const target = event.target.closest('button');
      if (!target) return;
      if (target.hasAttribute('data-cart-close')) return this.close();
      if (target.hasAttribute('data-cart-retry')) return this.open(this.trigger);
      if (target.hasAttribute('data-cart-continue')) { this.close(); return; }
      if (target.hasAttribute('data-cart-extra')) return this.addExtra();
      if (target.hasAttribute('data-cart-clear-foreign')) return this.mutate(() => this.request('cart/update.js', { updates: Object.fromEntries(this.foreign.map(item => [item.key, 0])) }));
      const row = target.closest('[data-group]');
      const group = row && this.groups.find(group => group.id === row.dataset.group);
      if (!group) return;
      const remove = target.hasAttribute('data-line-remove');
      const delta = target.hasAttribute('data-line-plus') ? 1 : target.hasAttribute('data-line-minus') ? -1 : 0;
      if (!remove && !delta) return;
      const quantity = remove ? 0 : Math.max(0, group.packs + delta);
      await this.mutate(() => this.changeGroup(group, quantity), group.id, delta > 0 ? '[data-line-plus]' : '[data-line-minus]');
    }
    async changeGroup(previous, packs) {
      const cart = await this.request('cart.js');
      const group = this.model.groups(cart.items).find(group => group.id === previous.id);
      if (!group || group.packs !== previous.packs || group.quantity !== previous.quantity) throw new Error('Dein Warenkorb hat sich inzwischen geändert. Bitte prüfe die aktuelle Menge.');
      if (group.isExtra && packs > 0) throw new Error('Das Zusatzangebot ist auf eine Flasche begrenzt.');
      if (packs > group.packs) {
        const items = group.items.map((item, index) => {
          const next = { id: item.variant_id, quantity: group.sizes[index] * (packs - group.packs), properties: item.properties };
          if (item.selling_plan_allocation) next.selling_plan = item.selling_plan_allocation.selling_plan.id;
          return next;
        });
        await this.request('cart/add.js?kaching_bundles=true', { items: items.filter(item => item.quantity > 0) });
      } else {
        await this.request('cart/update.js', { updates: this.model.updates(group, packs) });
      }
    }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: this.cart?.currency || this.dataset.currency || 'EUR' }).format(cents / 100); }
    render() {
      const cart = this.cart;
      const isGift = item => (this.giftProducts || []).some(gift => String(gift.variantId) === String(item.variant_id));
      const allowed = cart.items.filter(item => String(item.product_id) === this.dataset.productId || isGift(item));
      const foreign = cart.items.filter(item => !allowed.includes(item));
      this.foreign = foreign.length ? foreign : null;
      this.groups = this.model.groups(allowed);
      this.invalid = this.groups.some(group => !group.editable && group.items.some(item => item.properties?._natunora_line_size));
      if (this.invalid) this.error('Ein Paket ist unvollständig. Bitte entferne es und wähle dein Angebot erneut.');
      if (!this.model.giftsValid(this.model.giftPlan(cart.items, this.giftProducts || [], this.dataset.productId))) {
        this.invalid = true;
        this.error('Deine Gratisgeschenke konnten nicht korrekt angewendet werden. Bitte wähle dein Angebot erneut.');
      }
      const count = allowed.filter(item => !isGift(item)).reduce((sum, item) => sum + item.quantity, 0);
      this.querySelector('[data-cart-banner]')?.toggleAttribute('hidden', !count || !!foreign.length);
      this.querySelector('[data-cart-count]').textContent = `(${count})`;
      document.querySelectorAll('[data-natunora-cart-open]').forEach(link => {
        link.setAttribute('aria-label', `Warenkorb, ${count} Artikel`);
        let badge = link.querySelector('[data-natunora-cart-count]');
        if (!badge) { badge = document.createElement('span'); badge.dataset.natunoraCartCount = ''; badge.className = 'natunora-header__count'; link.append(badge); }
        badge.textContent = String(count); badge.hidden = !count;
      });
      const list = this.querySelector('[data-cart-items]');
      list.replaceChildren();
      if (foreign.length) {
        const box = document.createElement('div'); box.className = 'natunora-cart__empty';
        const p = document.createElement('p'); p.textContent = 'Dein Warenkorb enthält noch Artikel aus einem früheren Besuch. Entferne diese, um mit den Kollagen-Tropfen fortzufahren.';
        const button = document.createElement('button'); button.type = 'button'; button.dataset.cartClearForeign = ''; button.textContent = 'Frühere Artikel entfernen'; box.append(p, button); list.append(box);
      }
      if (!cart.item_count) {
        const box = document.createElement('div'); box.className = 'natunora-cart__empty';
        const h3 = document.createElement('h3'); h3.textContent = 'Dein Warenkorb ist noch leer.';
        const p = document.createElement('p'); p.textContent = 'Ein paar Tropfen. Eine tägliche Routine.';
        const button = document.createElement('button'); button.type = 'button'; button.dataset.cartContinue = ''; button.textContent = 'Weiter einkaufen'; box.append(h3, p, button); list.append(box);
      }
      for (const group of this.groups) {
        const fragment = this.querySelector('[data-cart-line-template]').content.cloneNode(true);
        const row = fragment.querySelector('article'); row.dataset.group = group.id;
        row.querySelector('[data-line-title]').textContent = /^natunora(?:\s|$)/i.test(group.title) ? group.title : `natunora ${group.title}`;
        row.querySelector('[data-line-pack]').textContent = group.isExtra ? 'Zusatzflasche' : `Auswahl: ${group.packTitle}`;
        const plan = row.querySelector('[data-line-plan]'); plan.textContent = group.plan ? 'Monatliche Lieferung' : ''; plan.hidden = !group.plan;
        if (group.isExtra && group.total >= group.original) { plan.textContent = 'Rabatt nur zusammen mit einem Paket.'; plan.hidden = false; }
        const properties = row.querySelector('[data-line-properties]');
        for (const [key, value] of Object.entries(group.items[0].properties || {})) if (!key.startsWith('_') && value) { const p = document.createElement('p'); p.textContent = `${key}: ${value}`; properties.append(p); }
        row.querySelector('[data-line-quantity]').textContent = group.packs;
        row.querySelector('.natunora-cart__quantity').hidden = !group.editable || group.isExtra;
        row.querySelector('[data-line-price]').textContent = this.money(group.total);
        const packImage = this.packImages?.[group.imageCount] || this.packImages?.[1];
        if (packImage) {
          row.querySelector('img').src = packImage;
          row.querySelector('img').alt = `Kollagen-Tropfen – ${group.imageCount === 3 || group.imageCount === 5 ? group.imageCount + ' Flaschen' : '1 Flasche'}`;
        }
        if (isGift(group.items[0])) {
          row.querySelector('[data-line-pack]').textContent = 'Digitales Geschenk';
          row.querySelector('.natunora-cart__quantity').hidden = true;
          row.querySelector('[data-line-remove]').hidden = true;
          row.querySelector('[data-line-price]').textContent = group.total === 0 ? 'Kostenlos' : this.money(group.total);
          const image = row.querySelector('img');
          image.src = group.items[0].image;
          image.alt = group.title;
        }
        const referenceTotal = group.items.reduce((sum, item) => {
          const variant = this.variantPrices[String(item.variant_id || item.id)];
          return sum + Math.max(item.original_line_price, Math.max(variant?.price || 0, variant?.compareAt || 0) * item.quantity);
        }, 0);
        const original = row.querySelector('[data-line-original]'); original.hidden = referenceTotal <= group.total; original.textContent = this.money(referenceTotal);
        list.append(fragment);
      }
      const shipping = this.querySelector('[data-cart-shipping]');
      const threshold = Number(this.dataset.shippingThreshold);
      shipping.hidden = !count || !!foreign.length || !['DE', 'AT'].includes(this.dataset.country) || cart.currency !== 'EUR' || threshold <= 0;
      this.querySelector('[data-cart-tax]').textContent = shipping.hidden
        ? 'Inkl. MwSt., Versand wird im Checkout berechnet.'
        : cart.total_price >= threshold ? 'Inkl. MwSt., kostenloser Versand' : `Inkl. MwSt., zzgl. ${this.money(490)} Versand`;
      if (!shipping.hidden) {
        const unlocked = cart.total_price >= threshold;
        const highlight = document.createElement('strong');
        highlight.textContent = unlocked ? 'kostenlos' : 'kostenlosen Versand';
        this.querySelector('[data-shipping-text]').replaceChildren(
          document.createTextNode(unlocked ? 'Dein Versand ist ' : `Noch ${this.money(threshold - cart.total_price)} bis zum `),
          highlight, document.createTextNode('!')
        );
        const percent = Math.min(100, Math.round(cart.total_price / threshold * 100));
        const progress = this.querySelector('[role="progressbar"]'); progress.setAttribute('aria-valuenow', percent); progress.style.setProperty('--progress', `${percent}%`);
      }
      const offer = this.querySelector('[data-cart-upsell]');
      if (offer) {
        offer.hidden = !count || !!foreign.length || this.groups.some(group => group.isExtra);
        offer.querySelector('[data-upsell-price]').textContent = this.money(Math.round(Number(offer.dataset.price) * (100 - Number(offer.dataset.discountPercent || 40)) / 100));
        const originalOfferPrice = offer.querySelector('[data-upsell-original]');
        if (originalOfferPrice) originalOfferPrice.textContent = this.money(Number(offer.dataset.price));
      }
      this.querySelector('[data-cart-footer]').hidden = !count || !!foreign.length;
      this.querySelector('[data-cart-total]').textContent = this.money(cart.total_price);
      const discounts = this.querySelector('[data-cart-discounts]'); discounts.replaceChildren();
      for (const discount of cart.cart_level_discount_applications || []) { const p = document.createElement('p'); p.textContent = `${discount.title}: −${this.money(discount.total_allocated_amount)}`; discounts.append(p); }
      this.lock(this.busy);
    }
    async cleanExtraCode() {
      const offer = this.querySelector('[data-cart-upsell]');
      if (!offer && !this.giftProducts?.length) return;
      const cart = await this.request('cart.js');
      await this.syncGifts(cart);
      const codes = (cart.discount_codes || []).map(discount => discount.code).filter(Boolean);
      if (offer && !cart.items.some(item => item.properties?._natunora_extra === 'true') && codes.some(code => code.toUpperCase() === offer.dataset.code.toUpperCase())) {
        await this.request('cart/update.js', { discount: codes.filter(code => code.toUpperCase() !== offer.dataset.code.toUpperCase()).join(',') });
      }
    }
    async syncGifts(cart) {
      const plan = this.model.giftPlan(cart.items, this.giftProducts || [], this.dataset?.productId);
      const updates = {}, additions = [];
      for (const gift of plan) {
        gift.lines.forEach((line, index) => {
          const desired = index === 0 ? gift.desired : 0;
          if (line.quantity !== desired) updates[line.key] = desired;
        });
        if (gift.desired && !gift.lines.length) additions.push({ id: gift.variantId, quantity: 1, properties: { _natunora_gift: 'true' } });
      }
      if (Object.keys(updates).length) await this.request('cart/update.js', { updates });
      if (additions.length) await this.request('cart/add.js?kaching_bundles=true', { items: additions });
    }
    async addExtra() {
      const offer = this.querySelector('[data-cart-upsell]');
      if (!offer || this.busy) return;
      await this.mutate(async () => {
        const before = await this.request('cart.js');
        if (!before.items.length || before.items.some(item => item.properties?._natunora_extra === 'true')) throw new Error('Bitte prüfe deinen aktuellen Warenkorb.');
        const codes = (before.discount_codes || []).map(discount => discount.code).filter(Boolean);
        try {
          await this.request('cart/add.js?kaching_bundles=true', { items: [{ id: Number(offer.dataset.variantId), quantity: 1, properties: { _natunora_extra: 'true' } }] });
          await this.request('cart/update.js', { discount: [...new Set([...codes, offer.dataset.code])].join(',') });
          const cart = await this.request('cart.js');
          const extra = cart.items.find(item => item.properties?._natunora_extra === 'true');
          const expected = Math.round(Number(offer.dataset.price) * (100 - Number(offer.dataset.discountPercent || 40)) / 100);
          if (!extra || extra.quantity !== 1 || extra.final_line_price > expected || cart.total_price > before.total_price + expected) throw new Error('Das Zusatzangebot lässt sich mit dieser Auswahl gerade nicht kombinieren.');
        } catch (error) {
          const current = await this.request('cart.js');
          const extra = current.items.find(item => item.properties?._natunora_extra === 'true');
          if (extra) await this.request('cart/change.js', { id: extra.key, quantity: 0 });
          await this.request('cart/update.js', { discount: codes.join(',') });
          throw error;
        }
      });
    }
  });
}
